import React from "react";

function Main(props) {
  return <>{props.children}</>;
}

export default Main;
